module.exports = __webpack_public_path__ + "static/media/ic_circle.d0ed6253.svg";